import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/header";
import LeftNavigation from "../../containers/activity/leftNavBar";
import Style from "./Activity.module.css";
import Notifications from "../../containers/activity/notifications/Notifications";
import NotificationSettings from "../../containers/activity/notificationSettings/NotificationSettings";

import Reminders from "../../containers/activity/reminders/Reminders";

const Account = () => {
  const location = useLocation();
  const [currentTab, setCurrentTab] = useState(1);

  const loadComponent = () => {
    switch (currentTab) {
      case 1:
        return <Notifications />;
      case 2:
        return <Reminders />;
      case 3:
        return <NotificationSettings />;
      default:
        return <Notifications />;
    }
  };

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("reminders")) {
      setCurrentTab(2);
    } else if (path.includes("settings")) {
      setCurrentTab(3);
    }
  }, []);

  return (
    <div className={Style.layout}>
      <div className={Style.mainWrapper}>
        <div className={Style.TopNavWrapper}>
          <Header />
        </div>
        <div className={Style.bodyWrapper}>
          <LeftNavigation
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
          {loadComponent()}
        </div>
      </div>
    </div>
  );
};

export default Account;
